import keys from '@debbie/common/dist/cache/keys.js';
import { getCollectorOnCase } from '@debbie/common/dist/cases/index.js';
import * as _collectors from '@debbie/common/dist/collectors/index.js';
import { PaymentPlanStatus, } from '@debbie/common/dist/economy/payment-plans/index.js';
import { FeatureFlag } from '@debbie/common/dist/feature-flags/index.js';
import { PaymentMethodStatus, providerPaymentTypeToPaymentType, } from '@debbie/common/dist/payment-methods/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { paymentPlans as paymentPlansApi } from '@debbie/cortex/dist/api/index.js';
import * as paymentPlansLib from '@debbie/cortex/dist/api/payment-plans.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useCustomer } from '@debbie/cortex/dist/customers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { paymentPlansEntity } from '@debbie/cortex/dist/paymentPlans/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { useVariation } from '../../../feature-flags/index.js';
import { errorNotification, successNotification, } from '../../../utils/errors.js';
import Button from '../../Button.js';
import PaymentType from '../../economy/case-vouchers/PaymentType.js';
import ExclusiveContent from '../../ExclusiveContent.js';
import CreditCard from '../../Icons/CreditCard.js';
import Input from '../../Input.js';
const PaymentMethods = (props) => {
    const { paymentPlan, singleCase } = props;
    const lang = useSelector((s) => s.lang);
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const collectorLoadable = useCollector((singleCase &&
        creditor &&
        getCollectorOnCase(singleCase.type, singleCase.collectorId, creditor.identityCollectorId, creditor.defaultCollectorId)) ||
        undefined);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const cardOption = (collector &&
        singleCase &&
        _collectors
            .getPaymentOptions(collector.paymentOptions, singleCase.currency)
            .filter((p) => !p.hideOnDebtorweb)
            .find((paymentOption) => paymentOption.isActive &&
            _collectors.PaymentOptionTypeToProviderMap[paymentOption.type])) ||
        null;
    // No hideOnDebtorweb filter: this is a caseworker action, not a debtor-web one.
    const mobilePeopleOption = collector === null
        ? null
        : (_collectors
            .getPaymentOptions(collector.paymentOptions, singleCase.currency)
            .find((paymentOption) => paymentOption.isActive === true &&
            paymentOption.type ===
                _collectors.PaymentOptionType.MOBILE_PEOPLE) ?? null);
    const hasBSMandateFlag = useVariation(FeatureFlag.MobilePeopleBSMandate) === true;
    const canConnectPaymentMethod = [
        PaymentPlanStatus.ACTIVE,
        PaymentPlanStatus.CREATED,
    ].includes(paymentPlan.status);
    const canCreateBSMandate = mobilePeopleOption != null && canConnectPaymentMethod;
    const customerLoadable = useCustomer(singleCase?.customerId);
    const customer = h.hasData(customerLoadable) ? customerLoadable.data : null;
    const debtor = customer?.users.find((user) => user.userOnCustomerId === singleCase?.userOnCustomerId) ||
        customer?.users.find((user) => user.relation === 'debtor') ||
        null;
    const debtorPrefill = {
        name: debtor?.details.name ?? '',
        cpr: debtor?.details.cpr ?? '',
    };
    const isPaymentMethodConnected = paymentPlan.paymentMethodStatus === PaymentMethodStatus.SAVED;
    const invalidatePaymentPlan = () => {
        q.invalidate(keys.write.modify(paymentPlansEntity, paymentPlan.paymentPlanId));
    };
    const deleteCardMutation = useMutation(() => paymentPlansLib.deleteCard(paymentPlan.paymentPlanId), {
        onSuccess: invalidatePaymentPlan,
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.paymentPlan);
        },
    });
    const connectPaymentMethodMutation = useMutation(async (offerBetalingsservice) => {
        if (!cardOption) {
            throw new Error('No active card payment option available');
        }
        const link = await paymentPlansApi.getPSPLink(paymentPlan.paymentPlanId, _collectors.PaymentOptionTypeToProviderMap[cardOption.type], cardOption.id, window.location.href, window.location.href, offerBetalingsservice);
        location.replace(link.url);
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.paymentPlan);
        },
    });
    return (React.createElement(Subsection, null,
        React.createElement(SubsectionHeader, null, lang.paymentPlans.paymentMethodSection),
        isPaymentMethodConnected ? (React.createElement(PaymentMethodConnected, null,
            React.createElement(ConnectedRow, null,
                React.createElement(ConnectedIcon, { $connected: true },
                    React.createElement(CreditCard, null)),
                React.createElement(ConnectedText, null,
                    React.createElement(ConnectedLabel, null, lang.paymentPlans.savedPaymentMethod),
                    paymentPlan.provider && paymentPlan.paymentMethodType && (React.createElement(PaymentType, { style: { display: 'block' }, paymentType: providerPaymentTypeToPaymentType(paymentPlan.provider, paymentPlan.paymentMethodType) || null })))),
            React.createElement(ActionFooter, null,
                React.createElement(Button, { onClick: () => {
                        if (confirm(lang.paymentPlans.areYouSureRemovePaymentMethod)) {
                            deleteCardMutation.mutate();
                        }
                    }, size: "mini", theme: "warning", loading: deleteCardMutation.isLoading }, lang.paymentPlans.removePaymentMethod)))) : (React.createElement(PaymentMethodMissing, null,
            React.createElement(ConnectedRow, null,
                React.createElement(ConnectedIcon, null,
                    React.createElement(CreditCard, null)),
                React.createElement(ConnectedText, null,
                    React.createElement(ConnectedLabel, null, lang.paymentPlans.noPaymentMethodConnected),
                    React.createElement(MissingHint, null, lang.paymentPlans.noPaymentMethodHint))),
            cardOption ? (React.createElement(ActionFooter, null,
                cardOption.type ===
                    _collectors.PaymentOptionType.MOBILE_PEOPLE && (React.createElement(ExclusiveContent, null,
                    React.createElement(Button, { onClick: () => connectPaymentMethodMutation.mutate(true), size: "mini", theme: "secondary", loading: connectPaymentMethodMutation.isLoading, disabled: !canConnectPaymentMethod, style: { marginRight: 8 } }, lang.paymentPlans.connectCardOrBetalingsservice))),
                React.createElement(Button, { onClick: () => connectPaymentMethodMutation.mutate(false), size: "mini", loading: connectPaymentMethodMutation.isLoading, disabled: !canConnectPaymentMethod }, lang.paymentPlans.connectPaymentMethod))) : (React.createElement(NoCardOptionHint, null, lang.paymentPlans.noActiveCardOption)),
            canCreateBSMandate &&
                (hasBSMandateFlag ? (React.createElement(BSMandateForm, { paymentPlan: paymentPlan, prefill: debtorPrefill, onSuccess: invalidatePaymentPlan })) : (React.createElement(ExclusiveContent, null,
                    React.createElement(BSMandateForm, { paymentPlan: paymentPlan, prefill: debtorPrefill, onSuccess: invalidatePaymentPlan }))))))));
};
export default PaymentMethods;
const BSMandateForm = (props) => {
    const { paymentPlan, prefill, onSuccess } = props;
    const lang = useSelector((s) => s.lang);
    const [open, setOpen] = useState(false);
    // null until edited, so the debtor prefill shows once it has loaded.
    const [editedName, setEditedName] = useState(null);
    const [editedCpr, setEditedCpr] = useState(null);
    const name = editedName ?? prefill.name;
    const cpr = editedCpr ?? prefill.cpr;
    const [regNo, setRegNo] = useState('');
    const [accountNo, setAccountNo] = useState('');
    const createMutation = useMutation(() => paymentPlansApi.createBSMandate(paymentPlan.paymentPlanId, {
        name,
        cpr,
        regNo,
        accountNo,
    }), {
        onSuccess: () => {
            successNotification(lang, 'create', lang.paymentPlans.createBSMandate, lang.paymentPlans.bsMandateCreated);
            setOpen(false);
            onSuccess();
        },
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.paymentPlan);
        },
    });
    const isValid = name.trim() !== '' &&
        cpr.trim() !== '' &&
        regNo.trim() !== '' &&
        accountNo.trim() !== '';
    if (!open) {
        return (React.createElement(ActionFooter, null,
            React.createElement(Button, { size: "mini", theme: "secondary", onClick: () => setOpen(true) }, lang.paymentPlans.createBSMandate)));
    }
    return (React.createElement(MandateForm, null,
        React.createElement(MissingHint, null, lang.paymentPlans.bsMandateDescription),
        React.createElement(Input, { placeholder: lang.paymentPlans.bsMandateName, value: name, onChange: (e) => setEditedName(e.target.value) }),
        React.createElement(Input, { placeholder: lang.paymentPlans.bsMandateCpr, value: cpr, onChange: (e) => setEditedCpr(e.target.value) }),
        React.createElement(Input, { placeholder: lang.paymentPlans.bsMandateRegNo, value: regNo, onChange: (e) => setRegNo(e.target.value) }),
        React.createElement(Input, { placeholder: lang.paymentPlans.bsMandateAccountNo, value: accountNo, onChange: (e) => setAccountNo(e.target.value) }),
        React.createElement(ActionFooter, null,
            React.createElement(Button, { size: "mini", theme: "secondary", onClick: () => setOpen(false), style: { marginRight: 8 } }, lang.misc.cancel),
            React.createElement(Button, { size: "mini", onClick: () => createMutation.mutate(), loading: createMutation.isLoading, disabled: !isValid }, lang.paymentPlans.bsMandateSubmit))));
};
const Subsection = styled.div `
  background: #fff;
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
`;
const SubsectionHeader = styled.h5 `
  margin: 0 0 4px 0;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #555;
`;
const PaymentMethodConnected = styled.div `
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const PaymentMethodMissing = styled.div `
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const ConnectedRow = styled.div `
  display: flex;
  align-items: center;
  gap: 12px;
`;
const ConnectedIcon = styled.div `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${(p) => (p.$connected ? '#e8f5ec' : '#f4f4f4')};
  color: ${(p) => (p.$connected ? '#1e7d3a' : '#888')};

  svg {
    width: 20px;
    height: 20px;
  }
`;
const ConnectedText = styled.div `
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;
const ConnectedLabel = styled.span `
  font-size: 13px;
  color: #666;
  font-weight: 500;
`;
const MissingHint = styled.span `
  font-size: 12px;
  color: #888;
  line-height: 1.4;
`;
const NoCardOptionHint = styled.p `
  margin: 0;
  padding: 8px 12px;
  background: #fff5e1;
  border: 1px solid #f1d990;
  border-radius: 6px;
  font-size: 12px;
  color: #8a6d3b;
  line-height: 1.4;
`;
const ActionFooter = styled.div `
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
`;
const MandateForm = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid #eee;
`;
//# sourceMappingURL=PaymentMethods.js.map